import { connect } from 'react-redux';

import {
  loadEveryoneLeaderboardAction,
  loadFriendLeaderboardAction,
  setEveryoneLeaderboardAction,
  setFriendLeaderboardAction,
} from '../../actions/dashboardActions';
import { getPossibleCyclesForUser } from '../../components/AccountSettings/AccountSettingsSelectors';
import {
  getEveryoneLeaderboard,
  getEveryoneLeaderboardWaiting,
  getFriendLeaderboard,
  getFriendLeaderboardWaiting,
} from '../../components/Dashboard/dashboardSelectors';
import Leaderboard from '../../components/Dashboard/Leaderboard/leaderboard.jsx';
import { getUser } from '../../components/User/userSelectors';

const mapStateToProps = (state, ownProps) => ({
  friendLeaderboard: getFriendLeaderboard(state),
  everyoneLeaderboard: getEveryoneLeaderboard(state),
  friendLeaderboardWaiting: getFriendLeaderboardWaiting(state),
  everyoneLeaderboardWaiting: getEveryoneLeaderboardWaiting(state),
  user: getUser(state),
  possibleCyclesForUser: getPossibleCyclesForUser(state),
});

const mapDispatchToProps = (dispatch) => ({
  loadFriendLeaderboard: (timePeriod) => {
    dispatch(loadFriendLeaderboardAction(timePeriod));
  },
  loadEveryoneLeaderboard: (timePeriod) => {
    dispatch(loadEveryoneLeaderboardAction(timePeriod));
  },
  setFriendLeaderboard: (friendLeaderboard) => {
    dispatch(setFriendLeaderboardAction(friendLeaderboard));
  },
  setEveryoneLeaderboard: (everyoneLeaderboard) => {
    dispatch(setEveryoneLeaderboardAction(everyoneLeaderboard));
  },
});

const LeaderboardContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Leaderboard);

export default LeaderboardContainer;
